import React from "react";
import {
  Redirect,
  generatePath,
  useLocation,
  useParams,
} from "react-router-dom";
import queryString from "query-string";
import { findingsQueryParams } from "../Findings/FindingsUtils";

const PRESERVED_QUERY_PARAMS = [
  findingsQueryParams.FILTER_ID,
  findingsQueryParams.FILTER_TO_EXECUTE,
  findingsQueryParams.SCOPE_ID,
  findingsQueryParams.SCOPE_TO_EXECUTE,
  findingsQueryParams.DATASOURCE,
  findingsQueryParams.RULE_NAME,
];

export interface RedirectPreservingParamsProps {
  to: string;
}

const RedirectPreservingParams: React.FC<RedirectPreservingParamsProps> = ({
  to,
}) => {
  const params = useParams();
  const { search } = useLocation();

  return (
    <Redirect
      to={{
        pathname: generatePath(to, params),
        search: queryString.pick(search, PRESERVED_QUERY_PARAMS),
      }}
    />
  );
};

export default RedirectPreservingParams;
